export enum Bookmaker {
  BETFAIR = 'Betfair',
  TAB = 'Tab',
  SPORTSBET = 'Sportsbet',
  POINTSBET = 'Pointsbet',
  UNIBET = 'Unibet',
  NEDS = 'Neds',
  LADBROKES = 'Ladbrokes',
  // BOOKMAKER = 'Bookmaker',
  TABTOUCH = 'Tabtouch',
  PALMERBET = 'Palmerbet',

  DABBLE = 'Dabble',
  //   MONEYBALL = 'Moneyball',

  // BLUEBET = 'Bluebet',
  BETRIGHT = 'Betright',

  // BETFLUX = 'Betflux',
  MINTBET = 'Mintbet',
  BAGGYBET = 'Baggybet',
  BETDELUXE = 'Betdeluxe',
  // WINBET = 'Winbet',
  // TEXBET = 'Texbet',
  REALBOOKIE = 'Realbookie',
  PICNICBET = 'Picnicbet',
  CROSSBET = 'Crossbet',
  ZBET = 'Zbet',
  WISHBET = 'Wishbet',
  PUNT123 = 'Punt123',
  MARANTELLIBET = 'Marantellibet',
  // GETSETBET = 'Getsetbet',
  OKEBET = 'Okebet',
  READYBET = 'Readybet',
  BETGOLD = 'Betgold',
  BOSSBET = 'Bossbet',
  // RAMBET = 'Rambet',
  ROBWATERHOUSE = 'Robwaterhouse',
  // SWIFTBET = 'Swiftbet',
  BETNATION = 'Betnation',
  UPCOZ = 'Upcoz',
  BETR = 'Betr',
  // FOXCATCHER = 'Foxcatcher',
  DIAMONDBET = 'Diamondbet',
  BITWINNING = 'Bitwinning',
  // THUNDERBET = 'Thunderbet',
  // ESKANDERBET = 'EskanderBet',
  SPORTCHAMPS = 'SportChamps',
  BETESTATE = 'Betestate',
  CHASEBET = 'Chasebet',
  PLAYWEST = 'PlayWest',
  NOISY = 'Noisy',
  PULSEBET = 'Pulsebet',
  PREMIUMBET = 'Premiumbet',

  PLAYUP = 'Playup',
  BOOKI = 'Booki',

  COLOSSALBET = 'Colossalbet',

  BOOMBET = 'Boombet',
  TOPSPORT = 'Topsport',
  // SOUTHERNCROSSBET = 'Southerncrossbet',
  ELITEBET = 'Elitebet',
  // WINNERSBET = 'Winnersbet',
  // JIMMYBET = 'Jimmybet',
  // BETBARN = 'Betbarn',
  // ACTIONBET = 'Actionbet',
  // BBET = 'Bbet',
  // WEBETNET = 'Webetnet',
  // BETHUNTER = 'Bethunter',
  // GOLDBET = 'Goldbet',
  // MIDASBET = 'Midasbet',
  VICBET = 'Vicbet',
  // BETDECK = 'Betdeck',
  // BETBETBET = 'BetBetBet',
  // PUNTERSPAL = 'PuntersPal',
  // ULTRABET = 'Ultrabet',
  BET66 = 'Bet66',
  HAVABET = "Havabet",

  // LYNCHBET = 'Lynchbet',
  // LUCASBET = 'Lucasbet',
  // PENDLEBURYBET = 'Pendleburybet',
  // TOMBET = 'Tombet',
  TRACKBET = 'Trackbet',
  WOODCOCKRACING = 'Woodcockracing',
  // VIPBETTINGSERVICES = 'Vipbettingservices',
  DAVEBET = 'Davebet',
  GALLOPBET = 'Gallopbet',
  // AUSSIEWAGERING = 'Aussiewagering',
  // RIVERBET = 'Riverbet',
  BARRINGTONBOOKMAKING = 'Barringtonbookmaking',
  // TOPODDS = 'Topodds',
  BEAZABET = 'Beazabet',
  BOOKIEPRICE = 'BookiePrice',

  // PUNTONDOGS = 'PuntOnDogs',
  PICKLEBET = 'Picklebet',
  // COMBET = 'Combet',
  BETM = 'BetM',
  SURGE = 'Surge',

  // BETGALAXY = 'Betgalaxy'
  PONYBET = 'Ponybet',
  DOWBET = 'Dowbet',

  STARSPORTS = 'Starsports',
  BETCHAMPS = 'Betchamps',
  TRADIEBET = 'Tradiebet',
  VINBET = 'Vinbet',

  TABNZ = 'Tab NZ',
}

export const bestPriceBookmakerPreferences = [
  Bookmaker.STARSPORTS,
  Bookmaker.PICKLEBET,
  Bookmaker.BOOMBET,
  Bookmaker.TOPSPORT,
  Bookmaker.HAVABET,
  Bookmaker.VICBET,
];

export const prefillBookmakers = [
  'Tab',
  'Sportsbet',
  'Pointsbet',
  'Unibet',
  'Neds',
  'Ladbrokes',
  // 'Bookmaker',
  'Tabtouch',
  'Palmerbet',

  //  'Dabble',

  // 'Bluebet',
  'Betright',

  // 'Betflux',
  'Mintbet',
  'Baggybet',
  'Betdeluxe',
  // 'Winbet',
  'Texbet',
  'Realbookie',
  'Picnicbet',
  'Crossbet',
  'Zbet',
  'Wishbet',
  'Punt123',
  'Marantellibet',
  // 'Getsetbet',
  'Okebet',
  'Readybet',
  'Betgold',
  'Bossbet',
  // 'Rambet',
  'Robwaterhouse',
  'Swiftbet',
  'Betnation',
  'Upcoz',
  'Betr',
  // 'Foxcatcher',
  'Diamondbet',
  'Bitwinning',
  // 'Thunderbet',
  // 'EskanderBet',
  'SportChamps',
  'Betestate',
  'Chasebet',

  'Playup',
  // 'Booki',

  'Colossalbet',

  'Boombet',
  'Topsport',
  // 'Southerncrossbet',
  'Elitebet',
  //  'Winnersbet',
  //  'Jimmybet',
  //  'Betbarn',
  //  'Actionbet',
  //  'Bbet',
  //  'Webetnet',
  //  'Bethunter',
  //  'Goldbet',
  //  'Midasbet',
  //  'Vicbet',
  //  'Betdeck',
  //  'BetBetBet',
  //  'PuntersPal',
  //  'Ultrabet',

  // 'Lynchbet',
  // 'Lucasbet',
  // 'Pendleburybet',
  // 'Tombet',
  'Trackbet',
  'Woodcockracing',
  // 'Vipbettingservices',
  'Davebet',
  'Gallopbet',
  // 'Aussiewagering',
  // 'Riverbet',
  'Barringtonbookmaking',
  // 'Topodds',
  'Beazabet',

  'PuntOnDogs',
  'Picklebet'
  //  'Combet',
  //  'BetM',
];

export const feedBookmakers = [
  'Topsport',
  'Boombet',
  // 'Southerncrossbet',
  'Vicbet',
  'Elitebet',
  'Havabet',

  // Punterstech
  'Starsports',
  'Betchamps',
  'Tradiebet',
  'Vinbet'
];
